export default __webpack_public_path__ + "static/media/alte-birebaum.40d65fe4.pdf";